import styled from "@emotion/styled";

export const CoverageToScale = styled.div`
  width: 100%;
  overflow-x: scroll;
  padding: 0px 16px 16px 40px;
  div.margin-overlay {
    position: absolute;
    width: 34px;
    height: 100%;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 1;
  }
`;
